import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Select, { TOption } from "../../../Components/Select";
import { TStateChangeCondition } from "./types";
import { useTranslation } from "react-i18next";

function generateStateOptions(states: string[]): TOption<string>[] {
  return states.map(function (topic): TOption<string> {
    return { value: topic };
  });
}

interface IStateChangeConditionFormProps {
  condition: TStateChangeCondition;
  states: string[];
  onChange: (stateChangeCondition: TStateChangeCondition) => void;
}

const StateChangeConditionForm = (props: IStateChangeConditionFormProps) => {
  const { condition, states, onChange } = props;
  const [stateOptions, setStateOptions] = useState<TOption<string>[]>(
    generateStateOptions(states)
  );
  const [state, setState] = useState<string>(condition.state || "<any>");
  const [previousState, setPreviousState] = useState<string>(
    condition.previous_state || "<any>"
  );
  const [stateChangeCondition, setStateChangeCondition] =
    useState<TStateChangeCondition>(condition);
  const { t } = useTranslation();

  useEffect(() => {
    setStateOptions(generateStateOptions(states));
    if (!states.includes(state)) {
      setState("<any>");
    }
    if (!states.includes(previousState)) {
      setPreviousState("<any>");
    }
  }, [states, state, previousState]);

  const updateStateChangeCondition = (
    newStateChangeCondition: TStateChangeCondition
  ) => {
    setStateChangeCondition(newStateChangeCondition);
    onChange(newStateChangeCondition);
  };

  return (
    <Box gap={1} display="flex" flexDirection="row" style={{ width: "100%" }}>
      <Select
        label={t("State")}
        value={state}
        options={stateOptions}
        onChange={(event) => {
          setState(event.target.value);
          updateStateChangeCondition({
            ...stateChangeCondition,
            state: event.target.value,
          });
        }}
        margin="none"
        style={{ width: "50%" }}
        data-cy="state-change-condition-select-state"
      />
      <Select
        label={t("Previous State")}
        value={previousState}
        options={stateOptions}
        onChange={(event) => {
          setPreviousState(event.target.value);
          updateStateChangeCondition({
            ...stateChangeCondition,
            previous_state: event.target.value,
          });
        }}
        margin="none"
        style={{ width: "50%" }}
        data-cy="state-change-condition-select-previous-state"
      />
    </Box>
  );
};

export default StateChangeConditionForm;
